import { IClassname } from '@/lib/shared/model/classname';

export const Photos = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7291 7.60838L13.8887 5.07715H8.11156L7.27124 7.60838H4.96036C4.12004 7.60838 3.38477 8.31712 3.38477 9.12712V15.4046C3.38477 16.2146 4.12004 16.9233 4.96036 16.9233H17.0399C17.8803 16.9233 18.6155 16.2146 18.6155 15.4046V9.12712C18.6155 8.31712 17.8803 7.60838 17.0399 7.60838H14.7291Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0004 14.3845C11.6736 14.3845 12.3193 14.1171 12.7953 13.641C13.2714 13.165 13.5388 12.5193 13.5388 11.8461C13.5388 11.1728 13.2714 10.5272 12.7953 10.0511C12.3193 9.57506 11.6736 9.30762 11.0004 9.30762C10.3271 9.30762 9.68147 9.57506 9.20541 10.0511C8.72936 10.5272 8.46191 11.1728 8.46191 11.8461C8.46191 12.5193 8.72936 13.165 9.20541 13.641C9.68147 14.1171 10.3271 14.3845 11.0004 14.3845Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
